( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( window ).width() > 1024 ) {
        // ADA close menu when focus shifts outside of it
        const handleFocusNav = function( navOpen ) {
          if ( navOpen ) {
            $( '.nav-open__focus' ).trigger( 'focus' );
            $( document ).on( 'keyup.navClose', function( event ) {
              if ( event.which === 27 ) {
                $( '.navbar-toggle' ).trigger( 'focus' );
                $( '.navbar-toggle' ).trigger( 'click' );
              }
            } );
          } else {
            $( document ).off( 'keyup.navClose' );
          }
        };
        $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
          if ( window.easyToggleState.isActive( event.target ) ) {
            /* handle ADA focus */
            handleFocusNav( true );
          } else {
            /* handle ADA focus */
            handleFocusNav( false );
          }
        } );

        // ADA close menu when focus shifts outside of it
        $( '.navigation-two-panel' ).on( 'focusout', function( e ) {
          const $menuItem = $( this );
          const newFocus = e.relatedTarget;

          if ( newFocus === null ) return;

          if ( !$menuItem.has( newFocus ).length && !$( newFocus ).hasClass( 'navbar-toggle' ) ) {
            $( '.navbar-toggle' ).trigger( 'click' );
            $( '.navbar-toggle' ).trigger( 'focus' );
          }
        } );

        // ADA send focus to first menu item when child menu is open
        $( '.primary-menu-item__link' ).on( 'toggleAfter', function( event ) {
          if ( window.easyToggleState.isActive( event.target ) ) {
            const target = $( this ).attr( 'data-toggle-target' );
            const firstLink = $( target ).find( 'a' ).get( 0 );
            setTimeout( () => {
              firstLink.focus();
            }, 50 );
          }
        } );

        // child-menu-panel
        $( '.child-menu-panel' ).on( 'focusout', function( e ) {
          const $menuItem = $( this );
          const newFocus = e.relatedTarget;
          if ( newFocus === null ) return;
          const panelBackBtn = $menuItem.find( 'button.nav-two__back-btn' ).get( 0 );

          if ( !$menuItem.has( newFocus ).length ) {
            $( panelBackBtn ).trigger( 'click' );
          }
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'navigation-two', COMPONENT );
} )( app );
